
import axios from "axios"
export default class SendEmail {

  multicr_api = process.env.VUE_APP_MULTICR;

  constructor() {
  }

  async sendEmail( process_type, title, body_mail, mailing_list, attachment_list) {
    let message = this.encryptBody(body_mail);
    return axios.post(this.multicr_api + "/enviar_correo", {
          tipo_de_proceso: process_type,
          titulo: title,
          mensaje_encriptado: message,
          correos: mailing_list,
          lista_de_adjuntos: attachment_list
      })
      .then((response) => {
        console.log("respuesta clase js: ",response);
        return response;
      })
      .catch((error) => {
        console.log("Se presentó un error al enviar el correo clase js: ",error);
      });
  }

  async sendQuotationmail(email, quote_id) {
    return axios.post(this.multicr_api + "/enviar_email_cotizaciones", {
        email: email,
        cotizacion_id: quote_id
      })
      .then((response) => {
        console.log("respuesta clase js: ",response);
        return response;
      })
      .catch((error) => {
        console.log("Se presentó un error al enviar el correo clase js: ",error);
      });
  }

  async sendPolicymail(email, issuance_id) {
    return axios.post(this.multicr_api + "/enviar_email_poliza", {
        email: email,
        emision_id: issuance_id
      })
      .then((response) => {
        console.log("respuesta clase js: ",response);
        return response;
      })
      .catch((error) => {
        console.log("Se presentó un error al enviar el correo clase js: ",error);
      });
  }

  encryptBody(html) {
    const header = {
      "alg": "HS256",
      "typ": "JWT"
    }
    const encodedHeader = Buffer.from(JSON.stringify(header)).toString('base64')

    var data = {
      "html": html
    }

    const encodedPayload = Buffer.from(JSON.stringify(data)).toString('base64')
    var jwtSecret = "u3E*aWShrxOv";
    const crypto = require('crypto')
    const signature = crypto.createHmac('sha256', jwtSecret).update(encodedHeader + '.' + encodedPayload).digest('base64')
    return encodedHeader + "." + encodedPayload + "." + signature
  }

}